import {
  Container,
  Divider,
  Grid,
  ThemeProvider,
  Typography,
} from '@material-ui/core'
import VerifyAccessCode from 'components/verify-access-code'
import { get } from 'lodash'
import { DateTime } from 'luxon'
import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import StepDescriptionOfferings from 'pages/schedule/step-description-offerings'
import { useStyles } from './styles'
import TimeSlotSelect from './time-slot-select'
import CoachLessonHeader from '../components/CoachLessonHeader'
import themes, { extendTheme } from 'themes'
import { aggregateByDate } from '../SelectLessonTime/utils'
import BackButton from '../components/BackButton'
import { useIsMobile } from 'lib/hooks'
import PropTypes from 'prop-types'
import ProgressIndicator from 'components/progress-indicators/progress-indicator'
import { flags, useFeatureFlags } from 'lib/feature-flags'

const SelectTimeLayout = ({
  lessonTypes,
  currentUrl,
  previousUrl,
  refetch,
  setShowRequestTime,
  lessonCreditBalanceQuantity,
}) => {
  const isMobile = useIsMobile()
  const timeSlots = get(lessonTypes, ['0', 'availableTimes']).map(
    t => t.startDateTime,
  )
  const datesWithAvailability = Object.keys(aggregateByDate(timeSlots)).sort()
  const firstAvailableDate = DateTime.fromISO(datesWithAvailability[0]).set({
    hour: 8,
  })
  const [selectedDate, setSelectedDate] = useState(firstAvailableDate)
  const coach = lessonTypes[0].coach
  const requiresAccessCode = get(lessonTypes, '0.requiresAccessCode')
  const location = useLocation()
  const [verifiedAccessCode, setVerifiedAccessCode] = useState(
    !requiresAccessCode || location?.state?.verifiedAccessCode,
  )
  const [showTimezone] = useFeatureFlags([flags.FLAG_TIMEZONE_EVENT_BOOKING])

  const classes = useStyles()

  return (
    <ThemeProvider theme={extendTheme(themes.offeringsRefresh)}>
      <Container style={{ marginBottom: '4rem' }}>
        <ProgressIndicator value={25} />
        <BackButton previousUrl={previousUrl} />
        <CoachLessonHeader
          lessonType={lessonTypes.length && lessonTypes[0]}
          coach={coach}
        />
        <Divider variant="fullWidth" />
        <Grid container direction={isMobile ? 'row' : 'row-reverse'}>
          <Grid item xs={12} style={{ marginTop: '2rem' }}>
            <StepDescriptionOfferings
              stepText="Step 1 of 3"
              previousUrl={previousUrl}
            />
            <Grid item style={{ marginBottom: '36px' }}>
              <Typography
                variant="h4"
                style={{ fontWeight: '700' }}
                className={classes.colorNavy}
              >
                Choose a Day and Time
              </Typography>
              <Typography
                variant="body1"
                style={{ margin: '16px 0px', fontWeight: 600 }}
              >
                Find a day and time that works best for your schedule below.
                {showTimezone
                  ? ' The available times are affiliated with the time zone of the facility.'
                  : ''}
              </Typography>
            </Grid>
            <Grid container item spacing={3} className={classes.timeSlotStyles}>
              <TimeSlotSelect
                data={lessonTypes}
                coach={lessonTypes[0].coach}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                currentUrl={currentUrl}
                refetch={refetch}
                setShowRequestTime={setShowRequestTime}
              />
            </Grid>
          </Grid>
        </Grid>
        <VerifyAccessCode
          lessonType={lessonTypes[0]}
          isOpen={!verifiedAccessCode && !lessonCreditBalanceQuantity}
          setIsOpen={setVerifiedAccessCode}
          coachName={coach.name}
          setVerifiedAccessCode={setVerifiedAccessCode}
        />
      </Container>
    </ThemeProvider>
  )
}

SelectTimeLayout.propTypes = {
  lessonTypes: PropTypes.array,
  currentUrl: PropTypes.string,
  previousUrl: PropTypes.string,
  refetch: PropTypes.func,
  setShowRequestTime: PropTypes.func,
  lessonCreditBalanceQuantity: PropTypes.string,
}
export default SelectTimeLayout
